const messages = {
    hello: 'Selamat datang',
    sign_in: 'Masuk'
}

export default messages;